import React from "react";

const StatusMessage = ({ filledStatus, status, reason,numberReason,type }) => {
  let message = "";
  let color = "";

  if (filledStatus === false && status === null) {
    message = "Please ensure the image is clear and legible.";
    color = "#999999";
  } else {
    if ((status === null || status === false) && filledStatus === true) {
      message = `${type} uploaded successfully`;
      color = "#999999";
    } else {
      if (status) {
        message = `${type} verified successfully`;
        color = "#00AC1A";
      } else {
        message = `${type} verification failed. ${reason}`;
        color = "red";
      }
    }
  }

  return (
    <>
      <p className="text-center mb-1" style={{ fontSize: "16px", color }}>
        {message}
      </p>
      {
        numberReason &&
        <p className="text-center mb-1" style={{ fontSize: "16px", color : 'red' }}>
          {numberReason}
        </p>
      }
    </>
  );
};

export default StatusMessage;
